import { apiRequest } from '../../shared/api/base'
import type { CortexEntry } from './types'

// ─── Response types ─────────────────────────────────────────

export interface CortexEntriesResponse {
  entries: CortexEntry[]
}

// ─── API functions ──────────────────────────────────────────

export async function getCortexEntries(): Promise<CortexEntriesResponse> {
  return apiRequest<CortexEntriesResponse>('/settings/cortex')
}

export async function deleteCortexEntry(id: string): Promise<{ id: string; deleted: boolean }> {
  return apiRequest<{ id: string; deleted: boolean }>(`/settings/cortex/${id}`, {
    method: 'DELETE',
  })
}
